import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=573c0296"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573c0296')) {
      api.createRecord('573c0296', component.options)
    } else {
      api.reload('573c0296', component.options)
    }
    module.hot.accept("./Snackbar.vue?vue&type=template&id=573c0296", function () {
      api.rerender('573c0296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Snackbar.vue"
export default component.exports